export default {
  mounted() {
    this.clipboardDestroyed = false
    this.copyLabel = this.el.getAttribute("aria-label")
    this.copyTip = this.el.dataset.tip
    this.setCopyFeedback = (state) => {
      const copied = state === "copied"
      this.el.querySelector(".copy-icon")?.classList.toggle("hidden", copied)
      this.el.querySelector(".check-icon")?.classList.toggle("hidden", !copied)
      this.el.dataset.copyState = state
      const label = copied ? this.el.dataset.copiedLabel : state === "failed" ? this.el.dataset.copyFailedLabel : this.copyLabel
      const visibleLabel = this.el.querySelector("[data-clipboard-label]")
      if (visibleLabel) visibleLabel.textContent = label || this.copyLabel
      const status = this.el.querySelector("[data-clipboard-status]")
      if (status) status.textContent = state === "idle" ? "" : (label || "")
      if (label) this.el.setAttribute("aria-label", label)
      if (this.copyTip) this.el.dataset.tip = state === "idle" ? this.copyTip : (label || this.copyTip)
    }
    this.copyClick = async () => {
      if (this.copyPending) return
      this.copyPending = true
      clearTimeout(this.copyTimer)
      try {
        await navigator.clipboard.writeText(this.el.dataset.clipboard || this.el.dataset.value || "")
        if (!this.clipboardDestroyed) this.setCopyFeedback("copied")
      } catch {
        if (!this.clipboardDestroyed) this.setCopyFeedback("failed")
      } finally {
        this.copyPending = false
        if (!this.clipboardDestroyed) this.copyTimer = setTimeout(() => this.setCopyFeedback("idle"), 1500)
      }
    }
    this.el.addEventListener("click", this.copyClick)
  },
  destroyed() {
    this.clipboardDestroyed = true
    clearTimeout(this.copyTimer)
    this.el.removeEventListener("click", this.copyClick)
  }
}
